import { render } from "./RegStepPopup.vue?vue&type=template&id=67e154fe"
import script from "./RegStepPopup.vue?vue&type=script&lang=js"
export * from "./RegStepPopup.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__